import { fetchProjects, fetchStatusList, changeStatus } from './admin/projects';
import { fetchUsers, createAccount, updateUsers } from './admin/users';
import { fetchAdminInfo, fetchMainContractors } from './admin/info';
import { fetchLogs } from './admin/logs';
import {
  fetchSubcontractorInfo,
  fetchRooms,
  reduceInfoToken,
  updateSubcontractorDescription,
  unlockProject,
  updateSubscription,
  enableProsperProBanner,
  updateSubscriptionHowToWin,
  claimToken,
  updateUserDetails,
} from './common/subcontractor';
import {
  fetchCompany,
  updateProfile,
  updateOffering,
  selectOption,
  updateCompanyImage,
  removeCompanyImage,
  updateOfferingsRegions,
  updateOfferingsTrades,
  updateCompanyDetails,
  getCompanyProfile,
} from './common/company';

import {
  fetchOpportunities,
  saveLatestOnLocal,
  fetchSingleProject,
  updateRegisteredProject,
  fetchOpportunitiesByAccount,
} from './common/opportunities';
import {
  fetchEnquiries,
  changeStatus as changeEnquiriesStatus,
  patchStatus as patchEnquiriesStatus,
  createQuote,
  nextBatch,
  tenderIsDownloaded,
  fetchDocumentsHistory,
} from './prosper/enquiries';
import {
  initFilter,
  changeFilter,
  changeDates,
  increaseLoaded,
  fetchFilterOptions,
  resetFilter,
} from './common/filters';
import { fetchInterests } from './prosper/registered_interests';
import {
  analyseFetch,
  analyseStart,
  setSeconds,
  setAnalysisDataReset,
  setCurrentTender,
  setTenderAnalysisData,
  clearPackageJob,
  clearJobError,
} from './clink/analyse-quote';
import {
  fetchTenderTemplates,
  createTenderTemplate,
  deleteTenderTemplate,
} from './clink/tender-templates';
import {
  fetchLoiTemplates,
  createLoiTemplate,
  deleteLoiTemplate,
} from './clink/loi-templates';
import {
  setOpenContactsModal,
  setSelectedTemplate,
  setTenderTemplates,
  mockPostContactsFailure,
  mockPostContactsSuccess,
} from './common/contacts';

import {
  fetchPrequalification as fetchPrequalification_V2,
  patchCompanyInformation as patchCompanyInformation_V2,
  fetchPrequalificationSections,
  patchTurnover as patchTurnover_V2,
  postPrequalFile as postPrequalFile_V2,
  resendReferences as resendReferences_V2,
  postReferences as postReferences_V2,
  addCertificate as addCertificate_V2,
  postOrganization as postOrganization_V2,
  patchOrganization as patchOrganization_V2,
  addTurnover as addTurnover_V2,
  updateTurnover as updateTurnover_V2,
  removeTurnover as removeTurnover_V2,
  updateSize as updateSize_V2,
  deletePrequalificationSection as deletePrequalificationSection_V2,
  deletePrequalificationReference as deletePrequalificationReference_V2,
  patchOrganizationV2 as patchOrganizationV2_V2,
  getPrequalification as getPrequalification_V2,
  requestDocument as requestDocument_V2,
  deleteTeamMember as deleteTeamMember_V2,
  changeLocalCompanyInfo as changeLocalCompanyInfo_V2,
  getPrequalificationSections,
  getPrequalificationStatuses,
} from './common/prequalification_v2';
import {
  fetchProject,
  fetchProjectGantt,
  updateTender,
  fetchProjectSummary,
  fetchPackageDependency,
  resetProject,
  setOpenedDatePickerId,
  setTasks,
  setOverview,
  resetOverview,
  addProject,
  updateProject,
  fetchTeamApi,
  postMember,
  deleteMember,
  updateMember,
  getProjectTenders,
  getProjectMilestones,
  fetchProjectEnquiries,
  updatePackages,
  getDashboardActions,
  removeOrRestoreDashboardAction,
  fetchShortlistedSubcontractors,
  fetchIfsProjects,
  resetIfsProjects,
  fetchLinkedIfsProject,
} from './clink/project';
import { setTitle, setType, setLock } from './prosper/Config';
import {
  fetchTeam,
  sendInvite,
  removeMemberTeam,
  changeRole,
  fetchAccounts,
  toggleStatus,
  updateAccounts,
  upgradeProsperPro,
  fetchCompany as fetchCompanyData,
  checkCompany,
  fetchGroups,
  addToSupplyChain,
  distance,
  toggleFirstPQQSend,
  fetchApprovalThresholds,
  updateApprovalThresholds,
  updateMemberPermissions,
  userRoles,
} from './common/account';
import {
  fetchInstructions,
  fetchInstruction,
  fetchStatus,
  fetchType,
  fetchSubcontractors,
  deleteInstruction,
  fetchForecastList,
  createInstruction,
  updateInstruction,
  changeBudget,
  blockAccess,
  changeInstructionStatus,
  resetInstruction,
} from './clink/instructions';
import {
  addDocument,
  changeUploadingDocumentsState,
  removeDocument,
  initialDocumentUpdate,
} from './clink/instructions/documents';
import {
  fetchOrders,
  deleteOrder,
  withdrawSentOrder,
  markAsSignOrder,
  restartOrders,
  sendApprovalReminder,
  assignOrderApprovers,
  withdrawOrderApproval,
  assignedOrderApprovers,
  rejectionAcknowledge,
  approveOrRejectOrder,
  assignedApproversforDocument,
  fetchOrderLogs,
} from './clink/orders';
import {
  fetchQuoteFiles,
  fetchQuoteDocuments,
  fetchQuotes,
  postQuote,
  editQuote,
  toggleCompliant,
  deleteQuote,
  award,
  toggledSelected,
  withdrawAward,
  updateProjectTender,
  resetQuotesTender,
} from './clink/quotes-tender';
import { fetchTemplates } from './clink/templates';
import { fetchTokens, fetchSupplyChainAnalytics } from './admin/analytics';
import { fetchSubscriptions, changeSubscription } from './common/subscription';
import { fetchActivities } from './admin/activity';
import { fetchEngagement } from './admin/engagement';
import { fetchAdminSupplyChain } from './admin/supply_chain';
import { checkToken, verifyToken } from './prosper/token';
import { fetchConstants } from './clink/constants';
import {
  fetchTrades,
  fetchRegions,
  fetchOpportunity,
} from './prosper/opportunity-viewer';
import { activateTeamAccount } from './prosper/teamManager';
import {
  fetchHealthScore,
  updateHealthScore,
} from './admin/customer_health_score';
import {
  setBreadcrumbs,
  setSlug,
  setProjectName,
  setLoaded,
} from './common/layout';

import {
  fetchBoQList,
  fetchBoQByTenderId,
  fetchBoQQuotes,
  fetchUnits,
  fetchProjectStatuses,
  createEntity,
  updateEntity,
  generateBoqWithAI,
  fetchGenerateBoqStatus,
  publishBoQ,
  setEntitySaved,
  setEditingMode,
  republishBoQ,
  quoteItems,
  quoteItemsDocs,
  publishQuote,
  republishQuote,
  setPackageNote,
  fetchOrderTemplates,
  setSubmitQuoteVars,
  setSelectedEntries,
  setEditingQuoteMode,
  setLocalLoadQuotes,
  changeCompliance, // duplicate from clink/quotes-tender. Pending refactor
  fetchQuoteHistory,
} from './common/boq';

import {
  fetchFeatures,
  fetchAccountFeatures,
  updateAccountFeatures,
  fetchAccountEnvelopes,
  updateAccountEnvelopes,
} from './common/features';

import {
  fetchAll,
  fetchBySubcontractorId,
  setTerm,
  setPaginationRowsPerPage,
  setContacts,
  setOrder,
  setDesc,
  setPaginationPage,
  setOffset,
  selectContact,
  addData,
  editData,
  removeData,
  getContacts,
  addContact,
  updateContact,
  removeContact,
  setMainContact,
} from './clink/supply-chain';

import {
  fetchRegions as fetchAttrRegions,
  fetchTrades as fetchAttrTrades,
  fetchProjectType as fetchAttrProjectType,
  fetchPublicTrades,
  fetchAsiteFolders,
} from './common/attributes';

import {
  getProjectProcurementOverviewV2,
  startMilestone,
  completeMilestone,
  getProjectProcurement,
  getProjectInterests,
  openEnquiryPro,
  restartProcurement,
  addToShortlistSubcontractors,
  fetchShortlistApprovers,
  fetchApproversWithLevels,
  fetchApproversShortlistedSubs,
  deleteShortlistedSubcontractor,
  requestShortlistApproval,
  approveOrRejectShortlistedSubcontractor,
  getShortlistedSubcontractorLogs,
  withdrawShortlistedSubcontractorApproval,
  acknowledgeRejection,
  sendShortlistedSubcontractorReminder,
  exportProcurementSchedule,
} from './clink/procurement-schedule';
import {
  getTenderRecommendations,
  createTenderRecommendationForm,
  getTenderRecommendationById,
  updateTenderRecommendationById,
  saveAsDraftTenderRecommendationById,
  getTenderRecommendationPricingSummary,
  updateTenderRecommendationPricingSummary,
  getTenderRecommendationApprovers,
  assignTenderRecommendationApprover,
  withDrawTenderRecommendation,
  sendTrApprovalReminder,
  approveOrRejectTenderRecommendation,
  getAuditLogsTenderRecommendationById,
  uploadTenderRecommendationAttachments,
  getTenderRecommendationAttachments,
  deleteTenderRecommendationAttachment,
} from './clink/tender-recommendation';

import {
  assignTenderInquiryApprover,
  approveRejectInquiry,
  acknowledgeRejectionFeedback,
} from './clink/tender-inquiry';

const actions = {
  admin: {
    fetchAttrRegions,
    fetchAttrTrades,
    fetchAttrProjectType,
    fetchPublicTrades,
    fetchProjects,
    fetchStatusList,
    changeStatus,
    initFilter,
    changeFilter,
    updateUsers,
    fetchUsers,
    fetchLogs,
    fetchMainContractors,
    fetchAdminInfo,
    fetchPrequalification_V2,
    patchCompanyInformation_V2,
    fetchPrequalificationSections,
    patchTurnover_V2,
    postPrequalFile_V2,
    addCertificate_V2,
    postReferences_V2,
    fetchCompany,
    updateProfile,
    updateOffering,
    selectOption,
    updateUserDetails,
    updateCompanyDetails,
    fetchFilterOptions,
    updateCompanyImage,
    removeCompanyImage,
    createAccount,
    fetchTokens,
    fetchSupplyChainAnalytics,
    updateAccounts,
    fetchAccounts,
    checkCompany,
    addToSupplyChain,
    toggleStatus,
    toggleFirstPQQSend,
    fetchSubscriptions,
    changeSubscription,
    fetchActivities,
    fetchOpportunitiesByAccount,
    fetchEngagement,
    fetchAdminSupplyChain,
    fetchHealthScore,
    updateHealthScore,
    fetchFeatures,
    fetchAccountFeatures,
    updateAccountFeatures,
    fetchAccountEnvelopes,
    updateAccountEnvelopes,
    fetchAsiteFolders,
  },
  prosper: {
    fetchAttrRegions,
    fetchAttrTrades,
    fetchAttrProjectType,
    fetchPublicTrades,
    setTitle,
    setType,
    setLock,
    fetchSubcontractorInfo,
    updateSubcontractorDescription,
    fetchOpportunities,
    saveLatestOnLocal,
    initFilter,
    changeFilter,
    changeDates,
    increaseLoaded,
    fetchEnquiries,
    nextBatch,
    fetchRooms,
    changeEnquiriesStatus,
    patchEnquiriesStatus,
    createQuote,
    fetchSingleProject,
    fetchInterests,
    updateRegisteredProject,
    fetchCompany,
    updateProfile,
    updateOffering,
    selectOption,
    updateUserDetails,
    updateCompanyDetails,
    fetchFilterOptions,
    resetFilter,
    updateCompanyImage,
    removeCompanyImage,
    updateOfferingsRegions,
    updateOfferingsTrades,
    reduceInfoToken,
    checkToken,
    verifyToken,
    fetchTrades,
    fetchRegions,
    fetchOpportunity,
    activateTeamAccount,
    fetchCompanyData,
    unlockProject,
    tenderIsDownloaded,
    changeSubscription,
    updateSubscription,
    enableProsperProBanner,
    updateSubscriptionHowToWin,
    claimToken,
    upgradeProsperPro,
    distance,
    fetchPrequalification_V2,
    patchCompanyInformation_V2,
    fetchPrequalificationSections,
    patchTurnover_V2,
    postPrequalFile_V2,
    resendReferences_V2,
    postReferences_V2,
    addCertificate_V2,
    postOrganization_V2,
    patchOrganization_V2,
    addTurnover_V2,
    updateTurnover_V2,
    removeTurnover_V2,
    updateSize_V2,
    deletePrequalificationSection_V2,
    deletePrequalificationReference_V2,
    patchOrganizationV2_V2,
    deleteTeamMember_V2,
    changeLocalCompanyInfo_V2,
    fetchProject,
    fetchBoQByTenderId,
    fetchBoQQuotes,
    fetchUnits,
    fetchProjectStatuses,
    updateEntity,
    quoteItems,
    quoteItemsDocs,
    publishQuote,
    republishQuote,
    setEntitySaved,
    setSubmitQuoteVars,
    fetchDocumentsHistory,
    setSelectedEntries,
    setEditingQuoteMode,
    getPrequalificationStatuses,
  },
  clink: {
    fetchAttrRegions,
    fetchAttrTrades,
    fetchAsiteFolders,
    fetchGroups,
    fetchAll,
    fetchBySubcontractorId,
    addData,
    editData,
    removeData,
    getContacts,
    addContact,
    updateContact,
    removeContact,
    setMainContact,
    setTerm,
    setPaginationRowsPerPage,
    setContacts,
    setOrder,
    setDesc,
    setPaginationPage,
    setOffset,
    selectContact,
    fetchConstants,
    fetchProject,
    fetchProjectGantt,
    fetchProjectSummary,
    fetchPackageDependency,
    resetProject,
    getDashboardActions,
    removeOrRestoreDashboardAction,
    setOpenedDatePickerId,
    setTasks,
    setOverview,
    resetOverview,
    fetchForecastList,
    fetchTeam,
    sendInvite,
    removeMemberTeam,
    changeRole,
    fetchApprovalThresholds,
    updateApprovalThresholds,
    updateMemberPermissions,
    userRoles,
    fetchInstructions,
    fetchInstruction,
    fetchStatus,
    fetchType,
    fetchSubcontractors,
    deleteInstruction,
    createInstruction,
    updateInstruction,
    changeBudget,
    blockAccess,
    changeInstructionStatus,
    resetInstruction,
    addDocument,
    changeUploadingDocumentsState,
    initialDocumentUpdate,
    removeDocument,
    updateTender,
    getCompanyProfile,
    fetchOrders,
    fetchQuoteFiles,
    deleteOrder,
    withdrawSentOrder,
    markAsSignOrder,
    sendApprovalReminder,
    assignOrderApprovers,
    withdrawOrderApproval,
    assignedOrderApprovers,
    assignedApproversforDocument,
    rejectionAcknowledge,
    approveOrRejectOrder,
    fetchOrderLogs,
    fetchTemplates,
    fetchQuotes,
    fetchQuoteDocuments,
    resetQuotesTender,
    restartOrders,
    postQuote,
    editQuote,
    toggleCompliant,
    deleteQuote,
    award,
    toggledSelected,
    withdrawAward,
    updateProjectTender,
    fetchOrderTemplates,
    fetchPrequalificationSections,
    getPrequalificationSections,
    fetchPrequalification_V2,
    getPrequalification_V2,
    requestDocument_V2,
    fetchBoQList,
    fetchUnits,
    fetchProjectStatuses,
    setSelectedEntries,
    setEntitySaved,
    setEditingMode,
    createEntity,
    updateEntity,
    generateBoqWithAI,
    fetchGenerateBoqStatus,
    publishBoQ,
    republishBoQ,
    fetchBoQByTenderId,
    fetchBoQQuotes,
    setPackageNote,
    setBreadcrumbs,
    setSlug,
    setProjectName,
    setLoaded,
    changeCompliance,
    analyseFetch,
    analyseStart,
    setAnalysisDataReset,
    setTenderAnalysisData,
    clearPackageJob,
    clearJobError,
    setSeconds,
    setCurrentTender,
    fetchQuoteHistory,
    setLocalLoadQuotes,
    getPrequalificationStatuses,
    addProject,
    updateProject,
    fetchTeamApi,
    postMember,
    deleteMember,
    getProjectTenders,
    fetchProjectEnquiries,
    updatePackages,
    updateMember,
    setOpenContactsModal,
    fetchLoiTemplates,
    createLoiTemplate,
    deleteLoiTemplate,
    fetchTenderTemplates,
    createTenderTemplate,
    deleteTenderTemplate,
    setSelectedTemplate,
    setTenderTemplates,
    mockPostContactsFailure,
    mockPostContactsSuccess,
    getProjectProcurementOverviewV2,
    getProjectMilestones,
    startMilestone,
    completeMilestone,
    exportProcurementSchedule,
    getProjectProcurement,
    getProjectInterests,
    openEnquiryPro,
    restartProcurement,
    getTenderRecommendations,
    createTenderRecommendationForm,
    getTenderRecommendationById,
    updateTenderRecommendationById,
    saveAsDraftTenderRecommendationById,
    getTenderRecommendationPricingSummary,
    updateTenderRecommendationPricingSummary,
    getTenderRecommendationApprovers,
    assignTenderRecommendationApprover,
    withDrawTenderRecommendation,
    sendTrApprovalReminder,
    approveOrRejectTenderRecommendation,
    getAuditLogsTenderRecommendationById,
    uploadTenderRecommendationAttachments,
    getTenderRecommendationAttachments,
    deleteTenderRecommendationAttachment,
    addToShortlistSubcontractors,
    fetchShortlistApprovers,
    fetchApproversWithLevels,
    fetchApproversShortlistedSubs,
    deleteShortlistedSubcontractor,
    requestShortlistApproval,
    approveOrRejectShortlistedSubcontractor,
    getShortlistedSubcontractorLogs,
    withdrawShortlistedSubcontractorApproval,
    acknowledgeRejection,
    sendShortlistedSubcontractorReminder,
    fetchShortlistedSubcontractors,
    assignTenderInquiryApprover,
    approveRejectInquiry,
    acknowledgeRejectionFeedback,
    fetchIfsProjects,
    resetIfsProjects,
    fetchLinkedIfsProject,
  },
};
export default actions;
